<div class="container-fluid">
    <div class="row">
        <div class="col-auto g-0  d-flex align-items-start">
            <div class="nav flex-column nav-pills px-1" id="v-pills-tab" role="tablist" aria-orientation="vertical">

                <button (click)="goBack()" class="nav-link btn-link" type="button" role="tab">
                    <i class="fas fa-arrow-left"></i> </button>

                <button class="nav-link" id="usecase-form-list-tab" data-bs-toggle="pill"
                    data-bs-target="#usecase-form-list" type="button" role="tab" aria-controls="usecase-form-list"
                    aria-selected="false"><i class="fa fa-list"></i></button>

                <button class="nav-link active btn-link" id="usecase-uiform-tab" data-bs-toggle="pill"
                    data-bs-target="#usecase-uiform" type="button" role="tab" aria-controls="usecase-uiform"
                    aria-selected="false"> <i class="fa fa-window-maximize me-0"></i></button>


                <button class="nav-link btn-link" id="usecase-chart-tab" data-bs-toggle="pill"
                    data-bs-target="#usecase-chart" type="button" role="tab" aria-controls="usecase-chart"
                    aria-selected="false"> <i class="fas fa-chart-pie"></i></button>

                <button class="nav-link btn-link " id="usecase-help-tab" data-bs-toggle="pill"
                    data-bs-target="#usecase-help" type="button" role="tab" aria-controls="usecase-help"
                    aria-selected="false"> <i class="fa fa-info-circle" aria-hidden="true"></i></button>

                <button class="nav-link btn-link" id="usecase-task-tab" data-bs-toggle="pill"
                    data-bs-target="#usecase-task" type="button" role="tab" aria-controls="usecase-task"
                    aria-selected="false"> <i class="fa fa-tasks" aria-hidden="true"></i></button>

                <div class="btn-group">
                    <button type="button" class="btn btn-link nav-link  dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fa fa-plus"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#" data-bs-target="#usecase-new">New project...</a></li>
                        <li><a class="dropdown-item" href="#" data-bs-target="#usecase-settings">Settings</a></li>
                        <li><a class="dropdown-item" href="#">Profile</a></li>
                    </ul>
                </div>

            </div>
        </div>
        <div class="col-11">
            <div class="tab-content" id="v-pills-tabContent">
                <div class="tab-pane fade" id="usecase-form-list" role="tabpanel"
                    aria-labelledby="usecase-form-list-tab">
                    <app-uiform-list [uiformId]="uiformId"></app-uiform-list>
                </div>
            </div>
            <div class="tab-pane fade show active" id="usecase-uiform" role="tabpanel"
                aria-labelledby="usecase-uiform-tab">

                 <app-uiform-edit [uiformId]="uiformId"> </app-uiform-edit>
            </div>
        </div>
    </div>

</div>